import React, { useEffect, useState } from "react";
import styles from "./DealerDetails.module.css";
import { Box, Button, MenuItem, Modal, Select } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import Chart from "react-apexcharts";
import { getDealerDirectory, getDealersData } from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";
import moment from "moment";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import DealerProfile from "./DealerProfile";

const messageStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  // maxWidth: 500,
  bgcolor: "background.paper",
  color: "text.primary",
  boxShadow: 24,
  p: 2,
  textAlign: "center",
};

const DealerDetail = ({ data, onClose }) => {
  const theme = useTheme();
  const [dealerData, setDealerType] = useState([]);
  const [open, setOpen] = useState(false);
  const [lat, setLat] = useState("");
  const [long, setLong] = useState("");
  const [skuCat, setskuCat] = useState("No Sku Sold");

  const [openDealerProfile, setOpenDealerProfile] = useState(false);

  console.log("datad1", data);

  useEffect(async () => {
    await getDealersData(data?.Kunnr)
      .then((d) => {
        // console.log("object12", JSON.stringifyd?.data?.prevMonthData);
        setDealerType(d?.data);
        setskuCat(
          d?.data?.salesData[0]?.category
            ? d?.data?.salesData[0]?.category
            : "No Sku Sold"
        );
      })
      .catch((err) => {
        toastMessage("error fetching data", "error");
      });
  }, [data]);

  console.log("sku cate", skuCat);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDealerProfileClose = () => {
    setOpenDealerProfile(false);
  };

  console.log("deale", JSON.stringify(dealerData));
  let currMonthSales = dealerData?.currMonthData?.reduce(
    (sum, item) => sum + item.totalQuantity,
    0
  );
  let lastMonthSales = dealerData?.prevMonthData?.reduce(
    (sum, item) => sum + item.totalQuantity,
    0
  );

  const calculatePercentage = (current, lastMonth) => {
    const percentage =
      isFinite(lastMonth) && lastMonth !== 0
        ? ((current - lastMonth) / lastMonth) * 100
        : 0;
    return isFinite(percentage) && !isNaN(percentage)
      ? percentage.toFixed(2)
      : 0;
  };

  return (
    <>
      <Box
        className={styles.dealer_profile}
        sx={{
          bgcolor: "background.paper",
          color: "text.primary",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <header className={styles.dealer_header}>
          {/* You can replace static content with dynamic data */}
          <p>
            Dealer Profile{" "}
            <span className={styles.dealer_name}> {data?.Name1}</span>
          </p>
          <div>
            <Button onClick={onClose} style={{ border: "1px solid gray" }}>
              <CloseIcon />
            </Button>
          </div>
        </header>

        <section className={styles.personal_information}>
          <div className={styles.personal_info_div_1}>
            <Box
              className={styles.dealer_img}
              sx={{
                bgcolor: "primary.main",
                color: "primary.contrastText",
                fontWeight: 700,
                fontSize: 28,
              }}
            >
              {data?.Name1.slice(0, 1)}
            </Box>
          </div>
          <div className={styles.personal_info_div2}>
            <h5>Personal Information</h5>
            <table>
              <tr>
                <th>Name</th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>
                  {data.Name1}
                </td>
              </tr>
              <tr>
                <th>Date of Joining</th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>
                  {moment(parseInt(data?.CrDate.match(/\d+/)[0])).format(
                    "DD/MM/YYYY"
                  )}
                </td>
              </tr>
              <tr>
                <th>Language</th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>
                  {"NA"}
                </td>
              </tr>
              <tr>
                <th>Date of Birth</th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>NA</td>
              </tr>
              <tr>
                <th>Marital Status</th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>NA</td>
              </tr>
              <tr>
                <th>Date of Anniversary</th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>NA</td>
              </tr>
            </table>
          </div>
          <div className={styles.contact_info}>
            <h5>Contact Details</h5>
            <table>
              <tr>
                <th>Email</th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>
                  {"NA"}
                </td>
              </tr>
              <tr>
                <th>Mobile Number</th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>
                  {data?.Mobile
                    ? data?.Mobile === ""
                      ? "NA"
                      : data?.Mobile
                    : "NA"}
                </td>
              </tr>
              <tr>
                <th>Location</th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>
                  {data?.Address}, {data?.City1}, {data?.Pincode}
                </td>
              </tr>
              <tr>
                <th></th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>
                  <Button
                    variant="text"
                    size="small"
                    sx={{
                      mt: 1,
                      px: 0,
                      fontWeight: 600,
                      fontSize: "14px",
                      color: "secondary.main",
                    }}
                    onClick={() => {
                      setOpen(true);
                      setLat(data?.Latitude ? data?.Latitude : "NA");
                      setLong(data?.Longitude ? data?.Longitude : "NA");
                    }}
                  >
                    Show on map
                  </Button>
                </td>
              </tr>
              <tr>
                <th></th>
                <td style={{ textAlign: "left", paddingLeft: "1rem" }}>
                  <Button
                    onClick={() => setOpenDealerProfile(true)}
                    variant="contained"
                    style={{ marginTop: "1rem", fontSize: "10px" }}
                  >
                    Dealer Profile
                  </Button>
                </td>
              </tr>
            </table>
          </div>
        </section>

        <section className={styles.performance}>
          <h3>Performance</h3>
          <div className={styles.performance_div}>
            <div className={styles.performance_div_1}>
              {/* <h5>Rotation</h5> */}
              <Chart
                type="donut"
                width={"200px"}
                height={"200px"}
                series={[
                  dealerData.Rotation * 100,
                  100 - dealerData.Rotation * 100,
                ]}
                options={{
                  labels: ["Remaining", "Utilized"],
                  theme: { mode: theme.palette.mode },
                  chart: {
                    foreColor: theme.palette.text.secondary,
                    background: "transparent",
                  },
                  colors: [
                    theme.palette.primary.main,
                    theme.palette.grey[500],
                  ],
                  title: {
                    text: "Rotation",
                    align: "center",
                    style: { color: theme.palette.text.primary },
                  },
                  yaxis: {
                    labels: {},
                  },
                  legend: {
                    position: "bottom",
                  },
                }}
              ></Chart>

              <p
                style={{
                  textAlign: "center",
                  fontFamily: "revert",
                  letterSpacing: "2px",
                  // marginTop: "1rem",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                {dealerData.Rotation ?? 0}
              </p>
            </div>
            <div className={styles.performance_div_2}>
              <p
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "-2rem",
                }}
              >
                <Button
                  startIcon={
                    ((currMonthSales - lastMonthSales) / lastMonthSales) * 100 >
                    0 ? (
                      <TrendingUpIcon />
                    ) : (
                      <TrendingDownIcon />
                    )
                  }
                  sx={{
                    color:
                      ((currMonthSales - lastMonthSales) / lastMonthSales) *
                        100 >
                      0
                        ? "success.main"
                        : "error.main",
                    fontWeight: 600,
                  }}
                >
                  {calculatePercentage(currMonthSales, lastMonthSales)} %
                </Button>
              </p>
              <Chart
                type="area"
                // width={"100%"}
                height={"200px"}
                series={[
                  {
                    name: "Mar' 24",
                    data: dealerData?.prevMonthData?.map(
                      (item) => item.totalQuantity
                    ),
                  },
                  {
                    name: "Apr' 24",
                    data: dealerData?.currMonthData?.map(
                      (item) => item.totalQuantity
                    ),
                  },
                ]}
                options={{
                  theme: { mode: theme.palette.mode },
                  colors: [
                    theme.palette.secondary.main,
                    theme.palette.primary.main,
                  ],
                  title: {
                    text: "Sales Performance",
                    align: "left",
                    style: { color: theme.palette.text.primary },
                  },
                  chart: {
                    foreColor: theme.palette.text.secondary,
                    background: "transparent",
                    toolbar: {
                      show: false, // Disable toolbar
                    },
                  },
                  grid: { borderColor: theme.palette.divider },
                  // tooltip: { followCursor: true },
                  yaxis: {
                    labels: {},
                  },
                }}
              />
            </div>
            <div className={styles.performance_div_3}>
              <p style={{ textAlign: "center", fontWeight: "bolder" }}>
                Top Selling SKUs
              </p>
              {/* <p>{dealerData?.salesData[0]?.category}</p> */}
              <div style={{ marginLeft: "2rem" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Select
                    labelId="zone-label"
                    value={skuCat}
                    name="skuCat"
                    onChange={(e) => setskuCat(e.target.value)}
                    // label="Category"
                    style={{ height: "30px", marginTop: "10px" }}
                  >
                    {dealerData?.salesData &&
                    dealerData?.salesData.length > 0 ? null : (
                      <MenuItem value="No Sku Sold">
                        <p>No Sku Sold</p>
                      </MenuItem>
                    )}
                    {dealerData?.salesData?.map((item) => (
                      <MenuItem key={item?.category} value={item.category}>
                        {item.category}
                      </MenuItem>
                    ))}
                  </Select>
                  {/* <p>
                    <Button
                      startIcon={
                        ((currMonthSales - lastMonthSales) / lastMonthSales) *
                          100 >
                        0 ? (
                          <TrendingUpIcon />
                        ) : (
                          <TrendingDownIcon />
                        )
                      }
                      style={{
                        color:
                          ((currMonthSales - lastMonthSales) / lastMonthSales) *
                            100 >
                          0
                            ? "green"
                            : "red",
                        fontWeight: "600",
                      }}
                    >
                      0 %
                    </Button>
                  </p> */}
                </div>
                <div
                  style={{
                    borderBottom: `2px dotted ${theme.palette.divider}`,
                    marginTop: "10px",
                  }}
                ></div>
                <table style={{ width: "100%" }}>
                  {dealerData?.salesData && dealerData?.salesData.length > 0 ? (
                    <>
                      {dealerData?.salesData
                        .filter((data) => data.category === skuCat)
                        .map((categoryData, index) => (
                          <tbody key={index}>
                            <tr></tr>
                            {categoryData.products.map(
                              (product, productIndex) => (
                                <tr
                                  key={productIndex}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <td
                                    style={{
                                      color: theme.palette.text.secondary,
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {product.ProductName}
                                  </td>
                                  <td
                                    style={{
                                      color: theme.palette.text.secondary,
                                      fontSize: "14px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {product.Quantity}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        ))}
                    </>
                  ) : null}
                </table>
              </div>
            </div>
            <div className={styles.performance_div_4}>
              <div>
                <p
                  style={{
                    fontFamily: "monospace",
                    fontWeight: "bolder",
                    fontSize: "16px",
                  }}
                >
                  Outstanding AOD
                </p>
                <p>{parseFloat(data?.OutTot) ?? 0}</p>
              </div>
              <div>
                <p
                  style={{
                    fontFamily: "monospace",
                    fontWeight: "bolder",
                    fontSize: "16px",
                  }}
                >
                  Overdue AOD
                </p>
                <p>{parseFloat(data?.OverDue) ?? 0}</p>
              </div>
            </div>
          </div>
          {/* Include charts or performance data */}
        </section>

        <section className={styles.club_performance}>
          {/* <h3>Club Performance</h3> */}
        </section>

        {/* ... other sections */}
      </Box>
      {openDealerProfile ? (
        <DealerProfile
          openDealerProfile={openDealerProfile}
          handleDealerProfileClose={handleDealerProfileClose}
          dealerProfile={data?.Kunnr}
          dealerType={data?.Dltype}
        />
      ) : null}
      <Modal open={open} onClose={handleClose}>
        <Box sx={messageStyle}>
          <iframe
            src={`https://maps.google.com/maps?q=${lat},${long}&hl=es;&output=embed`}
            height="500px"
            width="100%"
          ></iframe>
        </Box>
      </Modal>
    </>
  );
};

export default DealerDetail;
